<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokFeatureFleequidProps {
    blok: StoryblokFeatureFleequid;
}

// PROPS
const { blok } = defineProps<StoryblokFeatureFleequidProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['maxWidth']));
</script>

<template>
    <div v-editable="blok" class="lg:grid lg:grid-cols-2 lg:gap-x-8" :class="classes">
        <div class="space-y-6 py-8">
            <p v-if="!!blok.title" class="text-primary-800 text-3xl font-semibold">
                {{ blok.title }}
            </p>
            <StoryblokRichTextOverride v-if="!!blok.description" :doc="blok.description" class="max-w-none" />
        </div>
        <div class="space-y-6 rounded-xl border border-neutral-200 p-8">
            <p class="text-primary-800 flex flex-row items-center gap-x-6 text-3xl font-semibold">
                <UIcon name="fl:fleequid" class="h-[24px] w-[69px]" />
                Fleequid
            </p>
            <StoryblokRichTextOverride v-if="!!blok.fleequid" :doc="blok.fleequid" class="max-w-none" />
        </div>
    </div>
</template>
